import { AnalyticsParamsBag } from "../../MoneyTransfer/AnalyticsParamsBag.ts";
import { getPaymentStepConfig } from "./PaymentStepConfigRegistry.ts";

import { ItemType, NormasTeachingCheckoutFormData } from "../CheckoutData.ts";
import { NormasTeachingCheckoutItem } from "./PaymentMethodStepInterface.ts";

export function PaymentMethodRouter({
  checkoutData,
  itemType,
  normasTeachingItem,
  analyticsParams,
  onSuccess,
  onError,
  onBack,
}: {
  checkoutData: NormasTeachingCheckoutFormData;
  itemType: ItemType;
  normasTeachingItem: NormasTeachingCheckoutItem;
  analyticsParams?: AnalyticsParamsBag;
  onSuccess: () => void;
  onError: (message: string) => void;
  onBack: () => void;
}) {
  const selectedMethod = checkoutData.paymentMethod;

  const stepConfig = getPaymentStepConfig(selectedMethod);

  if (!stepConfig) {
    return (
      <div className="min-h-screen max-w-2xl mx-auto p-6 bg-white">
        <div className="text-center">
          <h2 className="text-xl font-bold text-red-600 mb-2">
            Metodo di pagamento non supportato
          </h2>
          <p className="text-gray-600 mb-4">
            Il metodo di pagamento selezionato non è disponibile.
          </p>
          <button
            onClick={onBack}
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Torna indietro
          </button>
        </div>
      </div>
    );
  }

  const StepComponent = stepConfig.StepComponent;

  return (
    <StepComponent
      checkoutData={checkoutData}
      itemType={itemType}
      item={normasTeachingItem}
      analyticsParams={analyticsParams}
      onSuccess={onSuccess}
      onError={onError}
      onBack={onBack}
    />
  );
}
